
import { css } from 'lit';
export default css`
pc-people-bio-hero [slot='nav']{
  display:flex;
  column-gap:1rem;
  align-items:center;
}

pc-people-bio-hero [slot='info'] pc-image{
  float:left;
  margin-right:var(--spacing-6);
  margin-bottom:var(--spacing-4);
  width:30%;
}

pc-people-bio-hero [slot='info'] pc-detail{
  margin-bottom:var(--spacing-2);
  color:var(--neutral-charcoal);
}

pc-people-bio-hero [slot='info'] pc-rectangle{
  --rectangle-color:var(--purple-indigo);
}

pc-people-bio-hero [slot='info'] pc-heading{
  --heading-font-size-mobile:var(--fs-h4-mobile);
  --heading-line-height:var(--lh-h4);
  margin-bottom:var(--spacing-2);
}

@media print{

pc-people-bio-hero [slot='info'] pc-heading{
    color:var(--neutral-dark-eggplant)
}
  }

pc-people-bio-hero [slot='info'] pc-heading small{
  font-family:var(--ff-body);
  font-size:var(--fs-body-mobile);
  font-weight:var(--fw-normal);
  display:block;
}

pc-people-bio-hero [slot='info'] .firmwide-titles{
  clear:both;
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body);
}

pc-people-bio-hero [slot='image'] img{
  width:calc((11 / 12) * 100%);
}

pc-people-bio-hero [slot='contact'] .locations{
  display:flex;
}

pc-people-bio-hero [slot='contact'] .contactWithPrint{
  display:flex;
  gap:1rem;
  justify-content:space-between;
}

pc-people-bio-hero [slot='contact'] .locations li{
  display:inline-flex;
  align-items:center;
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body);
}

pc-people-bio-hero [slot='contact'] .locations li::after{
  --rectangle-size:6px;
  --rectangle-color:var(--purple-indigo);
  display:inline-block;
  margin-right:var(--spacing-3);
  margin-left:var(--spacing-3);
  border-radius:2px;
  background:var(--rectangle-color);
  width:var(--rectangle-size);
  height:var(--rectangle-size);
  content:'';
}

@media print{

pc-people-bio-hero [slot='contact'] .locations li::after{
    --rectangle-size:4px
}
  }

pc-people-bio-hero [slot='contact'] .locations li:last-child::after{
  display:none;
}

pc-people-bio-hero [slot='contact'] .links{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-6);
}

pc-people-bio-hero [slot='contact'] .links > div{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-6);
}

@media print{

pc-people-bio-hero [slot='contact'] .links > div{
    gap:var(--spacing-1)
}
  }

pc-people-bio-hero [slot='contact'] .links > div:nth-child(2){
  display:flex;
  justify-content:space-between;
  flex-direction:row;
}

pc-people-bio-hero [slot='contact'] .social-links{
  display:flex;
  gap:var(--spacing-8);
  flex-wrap:wrap;
}

pc-people-bio-hero [slot='info'] .firmwide-titles{
  margin-bottom:var(--spacing-8);
}

@media print{

pc-people-bio-hero [slot='info'] .firmwide-titles{
    margin-bottom:var(--spacing-0)
}
  }

pc-people-bio-hero pc-icon-link a{
  word-break:break-all;
}

pc-people-bio-hero [slot='info'] pc-logo{
  display:none;
}

@media print{

pc-people-bio-hero [slot='info'] pc-logo{
    display:block;
    position:absolute;
    top:-7px;
    right:0
}
  }

@media (min-width: 520px){
  pc-people-bio-hero [slot='info'] .firmwide-titles{
    clear:none;
  }
}

@media (min-width: 768px){
  pc-people-bio-hero [slot='info'] pc-heading small{
    font-size:var(--fs-body);
    display:inline-block;
  }

  pc-people-bio-hero [slot='info'] .firmwide-titles{
    display:flex;
    flex-direction:column;
    gap:var(--spacing-2);
    font-size:var(--fs-body);
  }

  pc-people-bio-hero [slot='contact'] .locations li{
    font-size:var(--fs-body);
  }

  pc-people-bio-hero [slot='contact'] .locations li::after{
    margin-right:var(--spacing-4);
    margin-left:var(--spacing-4);
  }

  pc-people-bio-hero [slot='contact'] .links{
    display:grid;
    grid-template-columns:0.7fr 0.3fr;
  }

  pc-people-bio-hero [slot='contact'] .links > div:nth-child(2){
    flex-direction:column;
  }
}

@media print, (min-width: 992px){
  pc-people-bio-hero [slot='info'] pc-heading,
  pc-people-bio-hero [slot='info'] pc-detail{
    margin-bottom:var(--spacing-4);
  }

  pc-people-bio-hero [slot='info'] pc-image{
    display:none;
  }

  pc-people-bio-hero [slot='contact'] .links{
    gap:var(--spacing-16);
    padding-bottom:0.5rem;
  }
}

@media print{
  pc-people-bio-hero [slot='info'] pc-detail{
    margin-bottom:var(--spacing-0);
  }
  pc-people-bio-hero [slot='info'] pc-heading{
    margin-bottom:var(--spacing-0);
  }
}

pc-people-bio-hero [slot='contact'] .divider{
  background-color:var(--purple-indigo);
  width:0px;
  transition:all ease-in-out 0.5s;
  transition-delay:0.4s;
}

pc-people-bio-hero[loaded='true'] [slot='contact'] .divider{
  width:100%;
  transition:all ease-in-out 0.5s;
  transition-delay:0.4s;
}

pc-people-bio-hero [slot='nav'],
pc-people-bio-hero [slot='info'],
pc-people-bio-hero [slot='contact'] .locations,
pc-people-bio-hero [slot='contact'] .links{
  transform:translateY(20px);
  opacity:0;
}

pc-people-bio-hero[loaded='true'] [slot='image'],
pc-people-bio-hero[loaded='true'] [slot='nav'],
pc-people-bio-hero[loaded='true'] [slot='info'],
pc-people-bio-hero[loaded='true'] [slot='contact'] .locations,
pc-people-bio-hero[loaded='true'] [slot='contact'] .links{
  transform:translateY(0px);
  opacity:1;
  transition:all ease-in 0.4s;
}

@media print{
  pc-people-bio-hero [slot='image']{
    opacity:1 !important;
    visibility:visible !important;
    display:block !important;
  }
}
`;